// src/services/userService.ts
import { ISubscriptionResponse } from '@/types';
import api from './axios';

interface ContactReq {
  name: string,
  email: string,
  company: string,
  message: string

}

export const getUser = async () => {
  try {
    const response = await api.get('/user/me');
    if(response?.status === 200 && response?.data?.user.status === 200){
      return { success: true, message: 'User data fetched successfully', data: response.data.user };
    }
    return { success: false, message: 'Failed to fetch user data', error: response.data.message };
  } catch (error) {
    throw error;
  }
};

export const updateUser = async (userData: any) => {
  try {
    const response = await api.put('/user/edit-profile', userData);
    if (response.status === 200 && response.data.status === 200) {
      return { success: true, message: 'User data updated successfully', data: response.data.user };
    }
    return { success: false, message: 'Failed to update user data', error: response.data.message };
  } catch (error) {
    throw error;
  }
};

export const getSubscription = async (): Promise<ISubscriptionResponse> => {
  try {
    const response = await api.get('/subscription/v1/get-subscription-plan-details');
    if(response.status === 200){
      return {  success: true, message: 'Subscription data fetched successfully', data: response.data.data, error: null };
    }
    return { success: false, message: 'Failed to fetch subscription data', error: response.data.message, data: null};
  } catch (error) {
    throw error;
  }
};

export const completeUserOnboarding = async (data: any) => {
  try {
    const response = await api.post('/user/complete-onboarding', data);
    if(response.status === 200){
      return { success: true, message: 'Onboarding completed successfully' };
    }
    return { success: false, message: 'Failed to complete onboarding', error: response.data.message };
  } catch (error) {
    throw error;
  }
};

export const contactUsAPI = async (payload: ContactReq) => {
  const response = await api.post('/sales/contact', payload);
  if (response.status === 200) {
    return { success: true, data: response.data.data };
  }
  return {success: false, error: response.data};
};

export const contactCheck = async () => {
  const response = await api.get('/sales/check-request');
  if (response.status === 200) {
    return { success: true, data: response.data.data };
  }
  return {success: false, error: response.data};
};